enum WorkspaceSignupStep {
    COMPANY_NAME = 1,
    KEY_URL = 2,
    ADMIN_INFORMATION = 3,
    VERIFY = 4,
    SUCCESSFUL_VERIFICATION = 5,
}

export default WorkspaceSignupStep;
